import React from 'react'
import { compose } from 'recompose'
import { connect } from 'formik'
import { IntlShape, injectIntl } from 'react-intl'
import Step from '@src/components/AdvertisingCampaign/Form/Step'
import GroupHead from '@src/components/AdvertisingCampaign/Form/GroupHead'
import Textarea from '@iui-kit/components/Textarea'
import * as FIELD_NAMES from '@src/constants/AdvertisingBriefs/Social/fieldNames'
import { Formik } from '@src/types/BriefSocial/formikProps'
import Row from '@src/components/AdvertisingCampaign/Form/Row'

interface HOCProps {
  formik: Formik
  intl: IntlShape
}

const StepOne: React.FC<HOCProps> = (props: HOCProps) => {
  const {
    formik: { handleChange, handleBlur, values, errors, touched },
    intl: { formatMessage }
  } = props

  return (
    <Step title="Brief.network.step.one.title">
      <GroupHead
        title="Brief.network.step.one.head.title"
        subTitle="Brief.network.step.one.head.subTitle"
      />
      <Row>
        <Textarea
          size="m"
          name={FIELD_NAMES.GOODS}
          onChange={handleChange}
          handleBlur={handleBlur}
          value={values[FIELD_NAMES.GOODS]}
          isValid={!errors[FIELD_NAMES.GOODS] || !touched[FIELD_NAMES.GOODS]}
          placeholder={formatMessage({ id: 'Brief.network.field.goods.placeholder' })}
        />
      </Row>
      <GroupHead
        title="Brief.network.step.one.showRegions.title"
        subTitle="Brief.network.step.one.showRegions.subTitle"
      />
      <Row>
        <Textarea
          size="m"
          name={FIELD_NAMES.REGION}
          onChange={handleChange}
          handleBlur={handleBlur}
          value={values[FIELD_NAMES.REGION]}
          isValid={!errors[FIELD_NAMES.REGION] || !touched[FIELD_NAMES.REGION]}
          placeholder={formatMessage({ id: 'Brief.network.field.showRegions.placeholder' })}
        />
      </Row>
    </Step>
  )
}

export default compose<React.FC>(connect, injectIntl)(StepOne)
